var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInvestments48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 42.5029C33.9411 42.5029 42 34.4441 42 24.5029C42 14.5618 33.9411 6.50293 24 6.50293C14.0589 6.50293 6 14.5618 6 24.5029C6 34.4441 14.0589 42.5029 24 42.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36.3317C30.5327 36.3317 35.8285 31.0359 35.8285 24.5031C35.8285 17.9704 30.5327 12.6746 24 12.6746C17.4672 12.6746 12.1714 17.9704 12.1714 24.5031C12.1714 31.0359 17.4672 36.3317 24 36.3317Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4141 39.2788L11.958 41.4629",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5955 39.2734L36.0337 41.4694",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 30.1602C27.1248 30.1602 29.6575 27.6274 29.6575 24.5031C29.6575 21.3787 27.1248 18.8459 24.0004 18.8459C20.8761 18.8459 18.3433 21.3787 18.3433 24.5031C18.3433 27.6274 20.8761 30.1602 24.0004 30.1602Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInvestments48);
export default __webpack_public_path__ + "static/media/pictogramBeaconInvestments48.93ab7f463c4e752608354b4940a05725.svg";
export { ForwardRef as ReactComponent };